const Styles = {
  searchContainer: {
    mt: 3,
    mb: 3,
  },
  searchView: {
    display: 'flex',
    flexWrap: 'wrap',
    mt: 5,
    px: 6,
  },
  searchBtnView: {
    display: 'flex',
    flexDirection: 'row',
    px: 5,
    mb: 3,
    mt: 0,
    justifyContent: 'right',
  },
  resetBtn: {
    mr: 2,
  },
  editBtn: {
    mr: 2,
  },
  inputView: {
    width: 300,
  },
  addIcon: {
    fontSize: 'small',
    mr: 0.5,
  },
};

export default Styles;
